export const environment = {
  production: true,
  // api_ip : 'http://test-users.miurabox.com.mx/'
  api_ip : 'https://users-api.miurabox.info/',
};
